<template>
    <v-container>
        <v-row>
            <v-col>
                <div class="headline">Selskaper</div>
                <v-data-table class="table-with-row-pointer" @click:row="selectCompany" v-model="selected" show-select single-select :headers="headers" :items="companies" hide-default-footer disable-pagination :mobile-breakpoint="0">
                    <template v-slot:item.actions="{item}">
                        <v-btn icon color="success" @click.stop="updateCompany(item)">
                            <v-icon>mdi-autorenew</v-icon>
                        </v-btn>

                    </template>
                </v-data-table>

            </v-col>
            <v-col>
                <users :company="selected && selected.length ? selected[0] : undefined" class="ma-0 pa-0"></users>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import * as axios from "axios";
export default {
    data() {
        return {
            companies: [],
            selected: [],
            headers: [
                { text: "Navn", value: "name" },
                { text: "Brukere", value: "users.length" },
                { text: "Oppdater (BRREG)", value: "actions" }
            ]
        };
    },
    methods: {
        selectCompany(company) {
            this.$set(this.selected, 0, company);
        },
        async downloadCompanies() {
            let response = await axios.get("company", {
                params: {
                    include: "[users]"
                }
            });
            this.companies = response.data.sort((a,b) => {
                if(a.name > b.name) return 1;
                else if(a.name < b.name) return -1;
                else return 0;
            });
        },
        async updateCompany(company) {
            let response = await axios.get("brreg", {
                params: {
                    registrationnumber: company.registrationNumber
                }
            });

            if (response.status == 200 && response.data.totalOrganisations == 1) {
                let brreg_company = response.data.organisations[0]; // brreg result does not have ID ;)
                response = await axios.put(
                    `company/${company.id}`,
                    {
                        company: brreg_company
                    },
                    {
                        params: {
                            include: "[users]"
                        }
                    }
                );

                let index = this.companies.findIndex(c => c.id == response.data.id);
                if (index > -1) {
                    this.$set(this.companies, index, response.data);
                }

                this.$store.commit("snackbar", {
                    show: true,
                    text: `Oppdatert: ${response.data.name}`,
                    color: "success"
                });
            }
        }
    },
    mounted() {
        this.downloadCompanies();
    }
};
</script>

<style scoped>
.table-with-row-pointer >>> tr {
    cursor: pointer;
}
</style>